import ThemeMode from '~/client/src/shared/utils/ThemeModeManager'

import Colors from '~/client/src/shared/theme.module.scss'

interface IDeliveryPinColorState {
  isDone?: boolean
  isCanceled?: boolean
  isAssigned?: boolean
  isSelected?: boolean
}

// DeliveryStatus is a separate enum with its own palette, deliberately off the workflow status
// schema, so this stays a ladder. Selection resolves here too — applied on top by the pin, two
// places decided what "selected" looks like.
export function deliveryPinColors(state: IDeliveryPinColorState): {
  fill: string
  ink: string
} {
  const { isDone, isCanceled, isAssigned, isSelected } = state

  const fill = isSelected
    ? Colors.brandBlue
    : isDone
      ? Colors.neutral70
      : isCanceled
        ? Colors.neutral50_4
        : isAssigned
          ? Colors.warning70
          : Colors.neutral0

  // Yellow is the only fill light enough to need dark ink.
  const ink =
    isAssigned && !isSelected && !isDone && !isCanceled
      ? Colors.neutral0
      : Colors.neutral100

  return {
    fill: ThemeMode.getHEXColor(fill),
    ink: ThemeMode.getHEXColor(ink),
  }
}
